module.exports = __webpack_public_path__ + "static/media/section_2_B.331cdf9e.png";